import type { FacetConfiguration } from "../facet/type";

export type FilterTitleMode = "onlyTitle" | "full" | "onlyPopularValuesAndTitle" | "valuesAndTitle";

export type FilterMode = "default" | "sheetFirstLevel" | "sheetSecondLevel";

export type FilterConfiguration = {
  facetConfig: FacetConfiguration;
};

export type FontSize = "50" | "75" | "100" | "125";

export type FilterChipOptions = {
  fontSize?: FontSize;
  onclick?: () => void;
};

export type NextBestFilter = {
  id: string;
  title: string;
  selected?: boolean;
  itemCount?: number;
};

export type FilterModeConfigurations = {
  default: FilterConfiguration;
  sheetFirstLevel?: FilterConfiguration;
  sheetSecondLevel?: FilterConfiguration;
};

export type ConfigurableFilterOptions = {
  filterConfig: FilterModeConfigurations;
};

export function switchFilterMode(config: FilterModeConfigurations, mode: FilterMode): FilterConfiguration {
  if (!config[mode]) {
    return config.default;
  }
  return config[mode];
}
